<script>
	import { loadingSort } from "../../store/store";

	import LoaderSort from "./LoaderSort.svelte";

	let loader;
	loadingSort.subscribe((value) => {
		loader = value;
	});
</script>

{#if loader}
	<LoaderSort />
{:else}
	<slot />
{/if}
